import React, { Component } from "react";
import './Site.css';
import "react-datepicker/dist/react-datepicker.css";
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';

import {
  Row,
  Col,
} from 'reactstrap';
import { chartHelper } from "../helpers";

export default class SparkLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
  }

  render() {
    const width = this.props.width ? this.props.width : 200;
    const height = this.props.height ? this.props.height : 40;
    const margin = this.props.margin ? this.props.margin : 5;
    const color = this.props.color ? this.props.color : chartHelper.getListOfRandomHexColors(1, true);
    return (
      <div className="ml-4 mr-4">
        {this.props.title &&
          <Row>
            <Col><span className="boldText">{this.props.title}</span></Col>
          </Row>
        }
            <Row title={this.props.description}>
          <Col>
            <Sparklines data={this.props.data} svgWidth={width} svgHeight={height} margin={margin}>
              <SparklinesLine color={color} />
              <SparklinesSpots />
            </Sparklines>
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SparkLine.js